<template>
    <div
        class="flex flex-col items-center gap-2 border border-sky bg-blue p-4 md:border-0 md:p-0"
    >
        <div class="aspect-square w-full overflow-hidden">
            <img
                :src="image"
                :alt="title"
                class="h-full w-full object-cover"
                loading="lazy"
                decoding="async"
            />
        </div>
        <div
            class="relative -mt-20 flex flex-col items-center gap-2 md:-mt-8 lg:-mt-10"
        >
            <span class="text-6xl font-bold text-yellow md:block md:text-4xl">
                {{ correctValue }}
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import IconCheck from "./icons/IconCheck.vue";
import IconX from "./icons/IconX.vue";

defineProps<{
    image?: string;
    title?: string;
    correctValue?: string;
    correct: boolean;
}>();
</script>

<style scoped></style>
